import type { SportsApi } from "@/v2/api/metadata/sports";
import { buildFeedConfigTab } from "@/v2/kits/feed-config";
import { createSportFeedConfigApi } from "./sport-feed-config-api";

/** Saves are inline (toggle / drawer); dialog footer Save is a no-op on this tab. */
export function createFeedConfigTab(sportsApi: SportsApi) {
  return buildFeedConfigTab(createSportFeedConfigApi(sportsApi), {
    label: "Feed update configurations",
  });
}
